<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="权益申请"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onSubmit">
        <div class="batch-item">
          <!--   球杆序列号（只读，接收参数）     -->
          <van-field
              readonly
              name="number"
              :value="formData.number"
              label="球杆编码"
              placeholder="球杆编码"
              class="search-input"
              :rules="[{ required: true}]"
          />

          <!--   原因说明（默认喷面漆 禁用不可改）     -->
          <van-field name="checkType" label="原因说明" class="checktype-h"  :rules="[{ required: true, message: '请选择原因说明' }]">
            <template #input>
              <div class="check-type-radio-group">
                <van-radio-group v-model="formData.checkType" direction="horizontal">
                  <van-radio name="喷面漆">喷面漆</van-radio>
                </van-radio-group>
              </div>
            </template>
          </van-field>

          <!--   原因说明描述（红色字体）     -->
          <van-field
              v-model="formData.description"
              name="description"
              rows="2"
              autosize
              label=""
              readonly
              type="textarea"
              placeholder="请输入问题描述"
              class="desc-red"
          />

          <van-field name="fileList" label="问题图片" class="checktype-img" :rules="[{ required: true, message: '请上传问题图片' }]">
            <template #input>
              <van-uploader v-model="fileList" multiple :max-count="3" />
            </template>
          </van-field>

          <van-field v-model="formData.userName" name="userName" label="姓名" placeholder="请输入您的姓名" :rules="[{ required: true }]" />

          <van-field v-model="formData.telephone" name="telephone" label="电话" placeholder="请输入您的电话" :rules="[{ validator:telValidator }]"/>

          <van-field
              readonly
              clickable
              name="area"
              :value="provinceValue"
              label="地址"
              placeholder="点击选择省市区"
              @click="showArea = true"
              :rules="[{ required: true }]"
          />
          <van-popup v-if="showArea" v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                @confirm="onCityConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <van-field v-model="formData.detailAddr"
                     name="detailAddr"
                     rows="1"
                     autosize
                     type="textarea"
                     label="详细地址"
                     placeholder="请输入您的详细地址"
                     :rules="[{ required: true }]"
          />

          <div style="margin: 16px;">
            <van-button class="submit-btn" round block type="info" native-type="submit">提交申请</van-button>
          </div>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {afterPost} from "@/api/sales";
import {Dialog} from "vant";
import { areaList } from '@vant/area-data';

export default {
  data(){
    return {
      formData: {
        number: "",       // 球杆编码（来自路由 clubValue）
        checkType: "喷面漆",// 默认选中
        description: "",
        userName: "",
        telephone: "",
        province: "",
        city: "",
        detailAddr: "",
        brand: "",
        brandCode:  "",
        model: "",
        modelCode: "",
        equityId: "",
      },
      provinceValue: '',
      showArea: false,
      areaList,
      fileList: [],
    }
  },
  created() {
    // 从路由接收 clubValue
    const clubValue = this.$route.query.clubValue || '';
    if(clubValue){
      this.formData.number = clubValue;
    }

    const equityIntro = this.$route.query.equityIntro || '';
    if(equityIntro){
      this.formData.description = equityIntro;
    }

    const equityId = this.$route.query.equityId || '';
    if(equityId){
      this.formData.equityId = equityId;
    }


    const brand = this.$route.query.brand || '';
    if(brand){
      this.formData.brand = brand;
    }

    const brandCode = this.$route.query.brandCode || '';
    if(brandCode){
      this.formData.brandCode = brandCode;
    }

    const model = this.$route.query.model || '';
    if(model){
      this.formData.model = model;
    }

    const modelCode = this.$route.query.modelCode || '';
    if(modelCode){
      this.formData.modelCode = modelCode;
    }

  },
  methods: {
    telValidator(val) {
      if(val){
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(val)) {
          return false;
        }
      }else{
        return false;
      }
    },
    onSubmit(values){

      console.log(177,this.formData);
      const formData = new FormData();
      formData.append('number', values.number);
      formData.append('checkType', values.checkType);
      formData.append('description', values.description);
      formData.append('userName', values.userName);
      formData.append('telephone', values.telephone);
      formData.append('address', values.area.replaceAll('/','')+values.detailAddr);

      formData.append('oldBrand', this.formData.brand);
      formData.append('oldBrandCode', this.formData.brandCode);
      formData.append('oldModel', this.formData.model);
      formData.append('oldModelCode', this.formData.modelCode);
      formData.append('newId', this.formData.equityId);

      this.fileList.forEach(item => {
        if (item.file) {
          formData.append('rImg', item.file);
        }
      });

      afterPost(formData).then(res => {
        if(res.code===200){
          const data = res.data;
          if (data.code === 1) {
            this.showDialogMsg(data.returnMsg);
            this.formData = {
              number: this.$route.query.clubValue || '',
              checkType: "喷面漆",
              description: "购买2年内后把外观免费喷漆一次。(限面漆、磕碰较深处无法修复)",
              userName: "",
              telephone: "",
              province: "",
              city: "",
              detailAddr: "",
            }
            this.fileList = [];
          }else{
            this.showDialogMsg(data.returnMsg);
          }
        }else{
          this.showDialogMsg(res.returnMsg || '提交失败');
        }
      }).catch(() => {
        this.showDialogMsg('网络异常');
      });
    },
    onClickLeft() {
      this.$router.push('/app_myClub');
    },
    onCityConfirm(values){
      this.provinceValue = values
          .filter(item => item)
          .map(item => item.name)
          .join('/');
      this.showArea = false;
    },
    showDialogMsg(message){
      Dialog.alert({
        title: '提示',
        message: message,
        style: { width: '90%', maxWidth: 'none' }
      });
    },
  }
}
</script>

<style scoped lang="scss">
$black: #000000;
$gold: #D4AF37;
$dark-gold: #B8860B;

::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}

/* 原因说明描述 —— 红色字体 */
.desc-red {
  ::v-deep .van-field__control {
    color: red !important;
    font-weight: 500;
  }
}

.check-type-radio-group {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-height: 42px;

  @media (min-width: 768px) {
    flex-wrap: nowrap !important;
    overflow: hidden;
    height: 42px;
    line-height: 42px;

    ::v-deep .van-radio--horizontal {
      margin-bottom: 0 !important;
      margin-right: 25px !important;
      flex-shrink: 0;
      font-size: 15px !important;

      .van-radio__icon {
        width: 18px !important;
        height: 18px !important;
        margin-right: 8px !important;
        vertical-align: middle;
      }
    }
  }
}

.van-radio--horizontal{
  margin-bottom: 10px;
}

.top-bar{
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
}

.container-item {
  margin-bottom: 60px;
  @media (min-width: 768px) {
    padding: 0 20px;
    margin-bottom: 100px;
  }
}

.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
  @media (min-width: 768px) {
    padding: 20px;
    border-radius: 12px;
    margin: 20px auto;
    width: calc(100% - 40px);
    background: #fff;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }
}

.submit-btn{
  background: linear-gradient(135deg, $gold 0%, $dark-gold 100%);
  border: none;
  @media (min-width: 768px) {
    height: 80px;
    font-size: 36px;
    border-radius: 8px;
    &:hover {
      background: $dark-gold;
    }
  }
}

::v-deep .van-field {
  @media (min-width: 768px) {
    &[name="checkType"] {
      height: 42px !important;
      line-height: 42px !important;
    }
  }
}
.checktype-h{
  @media (min-width: 768px) {
    height: 150px;
  }
}

.checktype-img {
  @media (min-width: 768px) {
    min-height: 150px !important;
    height: auto !important;
    ::v-deep .van-uploader {
      width: 100% !important;
      display: flex !important;
      flex-wrap: nowrap !important;
      overflow-x: auto !important;
      gap: 10px !important;
      .van-uploader__upload,
      .van-uploader__preview {
        width: 100px !important;
        height: 100px !important;
        flex-shrink: 0 !important;
      }
    }
  }
}
</style>